/**
 * @internal
 */
export var ProductTypeUrlSuffixPlural = {
    Family: 'families',
    Group: 'groups',
    Product: 'products',
};
